export const GET_TRAINING_QUESTIONS = 'get_training_questions';
export const SUBMIT_TRAINING = 'submit_training';
export const DEFER_TRAINING = 'defer_training';
